import { convertPxToNumber } from './convert-px-to-number';

const computedStyle = getComputedStyle(document.documentElement);


export function getCssVarValue(name: string): string;
export function getCssVarValue(name: string, formatPxToNumber: true): number;
export function getCssVarValue(name: string, formatPxToNumber?: boolean): string | number {
    const value = computedStyle.getPropertyValue(`--${name}`).trim();

    return formatPxToNumber ? convertPxToNumber(value) : value;
}